export const DropdownOptionTemplate = (option: string) => (
  <span className='tw-text-text-50'>{option}</span>
)
